module.exports = __webpack_public_path__ + "media/images/illustrations/flat_list-efd112ff3177456b531ae594582229f4.png";